import { Shimmer } from '@n26/nxd'
import styles from './TransactionList.module.css'

const SkeletonRow = () => (
  <div className={styles.skeletonRow}>
    <Shimmer.Circle size={40} />
    <div className={styles.skeletonMain}>
      <Shimmer height={16} width={120} borderRadius='4' />
      <Shimmer height={14} width={80} borderRadius='4' />
    </div>
    <Shimmer height={16} width={64} borderRadius='4' />
  </div>
)

export const TransactionListSkeleton = () => (
  <>
    <SkeletonRow />
    <SkeletonRow />
    <SkeletonRow />
  </>
)
